import React from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import Styled from 'styled';

import CollectionView from 'lib/collection/collection-view';
import URLBuilderable from 'lib/url/url-builderable';
import LinkView from 'lib/ui/link-view';
import Avatar from 'four-nets/avatar/avatar';

import { UserLink } from './user-link';
import defaultStyles from './user-grid-list-view.scss';

export class UserGridListViewModel {
    @observable loading = false;
    @observable pagedResult;
    @observable users = [];

    constructor({ loadUsers, extractUsers }) {
        this.loadUsers = loadUsers;
        this.extractUsers = extractUsers || (user => user);
    }

    @action load = () => {
        this.loading = true;

        return this.loadUsers().then(this.loadDidSucceed).finally(this.loadDidFinish);
    };

    @action loadDidFinish = () => {
        this.loading = false;
    };

    @action loadDidSucceed = pagedResult => {
        this.pagedResult = pagedResult;
        this.users.replace(pagedResult.results.map(this.extractUsers));
    };

    @action loadPage = page => {
        if (this.pagedResult) {
            this.loading = true;
            return this.pagedResult.loadPage({ page }).then(this.loadDidSucceed).finally(this.loadDidFinish);
        }
        return this.load();
    };
}

@URLBuilderable()
@observer
class UserGridListItemView extends React.Component {
    link: UserLink;

    UNSAFE_componentWillMount() {
        const { user, urlBuilder } = this.props;

        this.link = new UserLink({
            user,
            urlBuilder,
        });
    }

    render() {
        const { user, styles } = this.props;
        const { link } = this;

        return (
            <LinkView key={user.id} link={link} className={styles.link}>
                <span className={styles.imageWrapper}>
                    <Avatar style={{ avatar: styles.avatar }} user={user} />
                    <span className={styles.label}>{link.label}</span>
                </span>
            </LinkView>
        );
    }
}

@Styled(defaultStyles)
@observer
class UserGridListView extends React.Component {
    element = user => <UserGridListItemView key={user.id} user={user} styles={this.props.styles} />;

    itemKey = user => user.id;
    isDraggable = () => false;

    render() {
        const { users } = this.props.userGridListViewModel;

        return (
            <CollectionView
                items={users}
                width={120}
                isDraggable={this.isDraggable}
                itemKey={this.itemKey}
                element={this.element}
            />
        );
    }
}

export default UserGridListView;
